import { performanceReportingApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import type { CreateEisRuleRequest, EisRuleListItem, UpdateEisRuleRequest } from '../_types';

export default function useManageEisRules() {
  const createRule = async (
    data: CreateEisRuleRequest,
    callback?: (data: EisRuleListItem) => void,
    onError?: (errors: ServerErrorResponse) => void,
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/eis/v1/rules`;
    await fetcher({
      url,
      method: 'POST',
      body: data,
    })
      .then((response) => {
        if (response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const updateRule = async (
    ruleId: number,
    data: UpdateEisRuleRequest,
    callback?: (data: EisRuleListItem) => void,
    onError?: (errors: ServerErrorResponse) => void,
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/eis/v1/rules/${ruleId}`;
    await fetcher({
      url,
      method: 'PUT',
      body: data,
    })
      .then((response) => {
        if (response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const deleteRule = async (
    ruleId: number,
    eisRuleVersionId: number,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void,
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/eis/v1/rules/${ruleId}/deactivate`;
    await fetcher({
      url,
      method: 'DELETE',
      body: { EisRuleVersionId: eisRuleVersionId },
    })
      .then((response) => {
        if (response && response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback();
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    createRule,
    updateRule,
    deleteRule,
  };
}
